export const CHART_MODEBAR_BUTTONS_TO_REMOVE = ["autoScale2d", "toImage"];

export const TRACE_1_COLOR = "rgb(128, 182, 244)";
export const TRACE_2_COLOR = "rgb(17, 208, 125)";
export const CARD_HEIGHT = "30vh";

export const EVALUATION_ENTITY_LIST = "evaluationEntityList";
export const SELECTED_ENTITY_LIST = "selectedEntityList";

export const ENTER_KEY_NAME = "Enter";
export const ENTITY_SELECT_OPTION_FONT_FAMILY = "Incosolata";
export const ENTITY_SELECT_SIZE = 4;

// Each chart rendered with Plotly's "scattergl" trace type opens its own WebGL
// context, and browsers cap the number of simultaneous WebGL contexts per page
// (commonly 8-16 depending on the browser/GPU). Only the charts with the most
// points (the ones that actually benefit from GPU rendering) are allowed to use
// scattergl; the rest fall back to the regular SVG "scatter" renderer.
export const MAX_WEBGL_CHART_TRACES = 8;
export const MIN_POINTS_FOR_WEBGL_TRACE = 500;

// Fields requested from GET /raw-datasets when loading the full list of
// AcquisitionPicture raw datasets for the acquisition report (charts, KPI
// table, quarantine drawer) — keeps the paginated payload light.
export const RAW_DATASET_FIELDS_FOR_REPORT =
    "uuid,name,s3Location,quarantine,type,dataType,channel,metadata";
// Matches the backend's PAGINATION.RAW_DATASETS.LIMIT.MAX: the largest page
// size allowed, to minimize the number of pagination round-trips.
export const RAW_DATASET_REPORT_PAGE_SIZE = 5000;

export const GSD_VALUE_LIMIT = Object.freeze([0, 100]);
export const SATURATION_VALUE_LIMIT = Object.freeze([0, 20]);
export const BLACK_SATURATION_VALUE_LIMIT = Object.freeze([0, 20]);
export const AlTITUDE_VALUE_LIMIT = Object.freeze([-20, 20]);
export const ALTUTUDE_OUTLIER_VALUE_LIMIT = Object.freeze([0, 20]);
